module.exports = __webpack_public_path__ + "fonts/Rift-Regular.a43fa9c3.ttf";